<template>
  <div class="session-details">
    <Progression v-if="loading"></Progression>
    <div v-else class="session-contents">
      <div
        v-if="$store.getters['site/user'].role !== 'student'"
        class="subtitle-1"
      >
        <h3 v-if="initSession.deletion" style="color:#ed1c24;">
          {{ $t("scheduler.session.cancelled") }}
        </h3>
      </div>

      <v-container fill-height fluid>
        <v-layout align-center justify-center>
          <v-flex md12>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="session.code"
                readonly
                prepend-icon="short_text"
                :label="$t('scheduler.session.fields.code')"
              ></v-text-field>
              <v-text-field
                v-model="session.description"
                :readonly="!canEdit()"
                prepend-icon="short_text"
                :rules="$rules('scheduler.session.description')"
                :label="$t('scheduler.session.fields.description')"
              ></v-text-field>
              <v-text-field
                v-model="session.creation"
                readonly
                prepend-icon="schedule"
                :label="$t('app.forms.fields.creation')"
              ></v-text-field>
              <v-text-field
                v-model="session.modification"
                readonly
                prepend-icon="schedule"
                :label="$t('app.forms.fields.modification')"
              ></v-text-field>
              <v-text-field
                v-model="session.deletion"
                readonly
                prepend-icon="schedule"
                :label="$t('app.forms.fields.deletion')"
              ></v-text-field>
            </v-form>
            <v-card-actions>
              <v-btn outlined @click="back">
                {{ $t("app.buttons.back") }}
              </v-btn>

              <v-spacer></v-spacer>

              <DeleteButton
                v-if="!!initSession && canEdit()"
                :message="$t('scheduler.session.messages.delete')"
                :name="$t('scheduler.session.name')"
                :soft="true"
                :endpoint="'/eventsgroups/' + initSession.id"
                @deleted="back"
              ></DeleteButton>

              <v-btn
                v-if="canEdit() && filled && valid"
                :readonly="!valid"
                dark
                color="primary"
                @click="submit"
              >
                {{ $t("app.buttons.submit") }}
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import Progression from "@/components/Progression";
import DeleteButton from "@/components/utilities/DeleteButton";
import adaptersOut from "@/services/data-adapter/outgoing/scheduler";

export default {
  components: {
    Progression,
    DeleteButton
  },

  props: {
    passedSession: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    initSession: null,
    loading: true,
    dialog: false,
    valid: true,
    session: null
  }),

  computed: {
    filled: function() {
      return this.sessionChanged && this.session.description;
    },
    sessionChanged: function() {
      return this.initSession.description != this.session.description;
    }
  },

  mounted: function() {
    this.$nextTick(async function() {
      this.initSession = this.passedSession;
      this.setSession();
      this.loading = false;
    });
  },

  methods: {
    setSession() {
      this.session = JSON.parse(JSON.stringify(this.initSession));
      this.loading = false;
    },

    canEdit() {
      const role = this.$store.getters["site/user"].role;
      return (
        !this.initSession.deletion && (role === "admin" || role === "teacher")
      );
    },

    async submit() {
      if (this.$refs.form.validate()) {
        adaptersOut.session(this.session).then(res => {
          const group = res;
          this.$http
            .put(
              "/eventsgroups/" + this.initSession.id + "?trashed=1",
              { group },
              {
                withCredentials: true,
                credentials: "include",
                mode: "cors"
              }
            )
            .then(request => this.submitSuccessful(request.data))
            .catch(error => this.submitFailed(error));
        });
      }
    },

    submitSuccessful(req) {
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "success",
          message: this.$t("app.actions.success.update")
        },
        { root: true }
      );
      this.reload();
    },

    submitFailed(error) {
      if (process.env.NODE_ENV !== "production") {
        console.log(error.response);
      }
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "error",
          message: this.$t("app.actions.failed.update")
        },
        { root: true }
      );
    },

    reload() {
      this.$router.go();
    },

    back() {
      this.$router.go(-1);
    }
  }
};
</script>
